// Cola de impresión de etiquetas.
//
// La app NO le habla directo a la impresora (el navegador no puede, y encima
// está en HTTPS). En su lugar, al confirmar el control se ENCOLA un trabajo en
// la colección `printJobs` de Firestore. Un "agente de impresión" corriendo en
// la PC-puente (ver carpeta /print-agent) escucha esa cola y manda la etiqueta
// a la impresora TSC por USB.

import { collection, addDoc, serverTimestamp } from "firebase/firestore";
import { db } from "../../../firebase";
import { getDireccionCliente, fetchDireccionClienteFinnegans, buscarCodigoClientePorNombre } from "./etiquetasFS";
import { getFlag, getEtiquetaFormato } from "./featureFlags";

// Resuelve la dirección del cliente de forma robusta: primero la guardada,
// después Finnegans (por código, y si no, resolviendo el código por nombre).
async function resolverDireccion(pedido) {
  const codigo = pedido?.clienteCodigo || null;
  try {
    const guardada = await getDireccionCliente(codigo);
    if (guardada?.direccion || guardada?.localidad) return guardada;
  } catch (_) {}
  try {
    let fin = codigo ? await fetchDireccionClienteFinnegans(codigo) : null;
    if ((!fin?.direccion && !fin?.localidad) && pedido?.cliente) {
      const codReal = await buscarCodigoClientePorNombre(pedido.cliente);
      if (codReal && codReal !== codigo) fin = await fetchDireccionClienteFinnegans(codReal);
    }
    if (fin?.direccion || fin?.localidad) return fin;
  } catch (_) {}
  return { direccion: "", localidad: "" };
}

/**
 * Encola la impresión de las etiquetas de un pedido (bultos + paquetes).
 * @param {object} pedido  documento del pedido (id, numero, cliente, deposito, clienteCodigo, metodoEntrega)
 * @param {object} opts    { bultos, paquetes, uid }
 * @returns {Promise<string>} id del trabajo encolado
 */
export async function encolarEtiquetas(pedido, { bultos = 0, paquetes = 0, uid = null } = {}) {
  // Interruptor global: si la impresión de etiquetas está desactivada (impresora
  // sin tinta, etc.), no se encola nada. El flujo del control sigue normal.
  if (await getFlag("ETIQUETAS_OFF")) {
    console.log("[etiquetas] impresión desactivada por flag ETIQUETAS_OFF — no se encola");
    return null;
  }

  const dir = await resolverDireccion(pedido);
  const formato = await getEtiquetaFormato(); // "doble" (7×4) | "unica" (10×5)

  const ref = await addDoc(collection(db, "printJobs"), {
    status: "pending",           // pending → printing → done | error
    tipo: "etiquetas",
    formato,                     // el print-agent lo usa para elegir el tamaño
    deposito: pedido?.deposito || "R8",
    pedidoId: pedido?.id || null,
    numero: pedido?.numero || pedido?.id || null,
    cliente: pedido?.cliente || "",
    clienteCodigo: pedido?.clienteCodigo || null,
    direccion: dir?.direccion || "",
    localidad: dir?.localidad || "",
    metodoEntrega: pedido?.metodoEntrega || "",
    bultos: Number(bultos) || 0,
    paquetes: Number(paquetes) || 0,
    createdAt: serverTimestamp(),
    createdBy: uid || null,
  });
  return ref.id;
}
